export const vendorIsReadOnlyCheck = (vendorId, permissions) => {
  let isReadOnly = true;
  permissions.forEach(permission => {
    // Global
    const entity_parts = permission.entity.split('/');
    if (permission.domain === 'vendor' && entity_parts.length === 1 && permission.update) {
      // Global vendor permission
      isReadOnly = false;
    }
    if (entity_parts.length === 2) {
      // Vendor specific permission
      const permissionVendorId = entity_parts[0];

      if (vendorId === permissionVendorId && permission.update) {
        isReadOnly = false;
      }
    }
  });
  return isReadOnly;
};

export const adminIsReadOnlyCheck = permissions => {
  let isReadOnly = true;
  permissions.forEach(permission => {
    // Global
    if (permission.domain === 'admin' && permission.update) {
      // Global vendor permission
      isReadOnly = false;
    }
  });
  return isReadOnly;
};

export const featureIsReadOnlyCheck = (featureId, permissions) => {
  let isReadOnly = true;
  permissions.forEach(permission => {
    // Check if user has admin permissions (admins should not be read-only)
    if (permission.domain === 'admin' && permission.update) {
      isReadOnly = false;
    }

    // Global feature permission
    const entity_parts = permission.entity.split('/');
    if (permission.domain === 'feature' && entity_parts.length === 1 && permission.update) {
      isReadOnly = false;
    }
    if (entity_parts.length === 2) {
      // Feature specific permission
      const permissionId = entity_parts[0];

      if (featureId === permissionId && permission.update) {
        isReadOnly = false;
      }
    }
  });
  return isReadOnly;
};

export const adminCanView = permissions => {
  let canView = false;
  permissions.forEach(permission => {
    // Global
    if (permission.domain === 'admin' && permission.read) {
      // Global vendor permission
      canView = true;
    }
  });
  return canView;
};
